import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=57922c6b&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=57922c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57922c6b",
  null
  
)

export default component.exports